module.exports = __webpack_public_path__ + "static/media/cross.1ef9082c.svg";